export default class AlphabeticalNav {

    constructor(element) {
        element.addEventListener('click', this.clickHandler.bind(this));
        this.navItems = [...element.querySelectorAll('li')]
    }

    clickHandler(event) {
        const filter = event.target.dataset.filter;
        this.filter = (filter === this.filter) ? null : filter;
        this.updateUI();
    }

    updateUI() {
        const elements = [...document.querySelectorAll('.search-result')];

        elements.forEach(element => {
            const letter = element.dataset.letter;
            console.log(letter, this.filter);
            const func = (letter === this.filter || !this.filter) ? 'remove' : 'add';
            element.classList[func]('hidden');
        })

        this.navItems.forEach(item => {
            const btn = item.firstElementChild;
            const letter = btn.dataset.filter;
            const func = (letter === this.filter || !this.filter) ? 'add' : 'remove';
            item.classList[func]('active');
        })
    }
}